import AdviserProfilesApi from '../../../core/api/AdviserProfilesApi'
const api = new AdviserProfilesApi()

export const FETCHED_ADVISORPROFILECONTAINER_PROFILE = 'FETCH_PUBLISHED_PROFILE'
export const FETCHING_ADVISORPROFILECONTAINER_PROFILE = 'FETCHING_PUBLISHED_PROFILE'

export const fetchingPublishedProfile = (adviserId) => ({
  type: FETCHING_ADVISORPROFILECONTAINER_PROFILE,
  adviserId
})

export function fetchPublishedProfile (adviserId, publishedProfiles) {
  var profile = publishedProfiles.find((profile) => profile.adviserId === adviserId)
  var request
  if (!profile) {
    request = api.getPublishedAdviserProfile(adviserId)
  }
  return (dispatch) => {
    dispatch(fetchingPublishedProfile(adviserId))
    if (profile) {
      dispatch({
        type: FETCHED_ADVISORPROFILECONTAINER_PROFILE,
        payload: profile
      })
    } else {
      request.then(function (response) {
        dispatch(api.handleResponse(FETCHED_ADVISORPROFILECONTAINER_PROFILE, response))
      })
    }
  }
}
